import React from 'react';

const ICONS = {
    badge: (
        <>
            <circle cx="12" cy="8" r="6" />
            <path d="M15.5 13.2 17 22l-5-3-5 3 1.5-8.8" />
        </>
    ),
    globe: (
        <>
            <circle cx="12" cy="12" r="9.5" />
            <path d="M2.5 12h19" />
            <path d="M12 2.5a13.5 13.5 0 0 1 0 19 13.5 13.5 0 0 1 0-19Z" />
        </>
    ),
    graduation: (
        <>
            <path d="M2 9 12 4l10 5-10 5L2 9Z" />
            <path d="M6 11.5V16c0 1.4 2.7 2.5 6 2.5s6-1.1 6-2.5v-4.5" />
        </>
    ),
    shield: <path d="M12 22c4.5-1.5 8-4 8-9V5l-8-3-8 3v8c0 5 3.5 7.5 8 9Z" />,
    layout: (
        <>
            <rect x="3" y="3.5" width="18" height="17" rx="2" />
            <path d="M3 9h18" />
            <path d="M9.5 9v11.5" />
        </>
    ),
    shieldCheck: (
        <>
            <path d="M12 22c4.5-1.5 8-4 8-9V5l-8-3-8 3v8c0 5 3.5 7.5 8 9Z" />
            <path d="m8.8 11.8 2.3 2.3 4.1-4.6" />
        </>
    ),
    link: (
        <>
            <path d="M9 17H7A5 5 0 0 1 7 7h2" />
            <path d="M15 7h2a5 5 0 1 1 0 10h-2" />
            <path d="M8 12h8" />
        </>
    ),
    bolt: <path d="M13 2 4 14h7l-1 8 9-12h-7l1-8Z" />,
    gift: (
        <>
            <rect x="3" y="8" width="18" height="4" rx="1" />
            <path d="M12 8v13" />
            <path d="M19 12v7a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-7" />
            <path d="M7.5 8a2.5 2.5 0 0 1 0-5C11 3 12 8 12 8s1-5 4.5-5a2.5 2.5 0 0 1 0 5" />
        </>
    ),
    chart: (
        <>
            <path d="M3 3v18h18" />
            <path d="M18 17V9" />
            <path d="M13 17V5" />
            <path d="M8 17v-3" />
        </>
    ),
    target: (
        <>
            <circle cx="12" cy="12" r="9" />
            <circle cx="12" cy="12" r="5" />
            <circle cx="12" cy="12" r="1.3" fill="currentColor" stroke="none" />
        </>
    ),
    mobile: (
        <>
            <rect x="6" y="2" width="12" height="20" rx="2.5" />
            <path d="M11 18h2" />
        </>
    ),
    palette: (
        <>
            <circle cx="12" cy="12" r="9.5" />
            <circle cx="8.5" cy="9" r="1.1" fill="currentColor" stroke="none" />
            <circle cx="15.5" cy="9" r="1.1" fill="currentColor" stroke="none" />
            <circle cx="9.5" cy="15.5" r="1.1" fill="currentColor" stroke="none" />
        </>
    ),
    lock: (
        <>
            <rect x="4" y="11" width="16" height="10" rx="2" />
            <path d="M8 11V7a4 4 0 0 1 8 0v4" />
        </>
    ),
    plug: (
        <>
            <path d="M9 7V2" />
            <path d="M15 7V2" />
            <path d="M6 13V7h12v6a4 4 0 0 1-4 4h-4a4 4 0 0 1-4-4Z" />
            <path d="M12 21v-4" />
        </>
    ),
    tag: (
        <>
            <path d="M3 4v7.6a1 1 0 0 0 .3.7l8.4 8.4a1 1 0 0 0 1.4 0l6.6-6.6a1 1 0 0 0 0-1.4L11.7 4.3a1 1 0 0 0-.7-.3H4a1 1 0 0 0-1 1Z" />
            <circle cx="7.5" cy="7.5" r="1.3" fill="currentColor" stroke="none" />
        </>
    ),
    email: (
        <>
            <rect x="3" y="5" width="18" height="14" rx="2" />
            <path d="m3.5 7 8.5 6 8.5-6" />
        </>
    ),
    trending: (
        <>
            <path d="M3 17 9 11l4 4 7-7" />
            <path d="M16 8h5v5" />
        </>
    ),
    signature: (
        <>
            <path d="M12 20h9" />
            <path d="M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4Z" />
        </>
    ),
    map: (
        <>
            <path d="M9 4 3 6v14l6-2 6 2 6-2V4l-6 2-6-2Z" />
            <path d="M9 4v14" />
            <path d="M15 6v14" />
        </>
    ),
    search: (
        <>
            <circle cx="11" cy="11" r="7" />
            <path d="m16.5 16.5 4.5 4.5" />
        </>
    ),
    rocket: (
        <>
            <path d="M12 15l-4-4c2-5 5-8 11-8 0 6-3 9-8 11Z" />
            <path d="M9 12H5s.4-2.8 3-4" />
            <path d="M12 15v4s2.8-.4 4-3" />
            <path d="M5 16.5c-1.2 1-1.6 4-1.6 4s3-.4 4-1.6a1.7 1.7 0 1 0-2.4-2.4Z" />
        </>
    ),
};

export function Icon({ name, size = 24, color = 'currentColor', strokeWidth = 1.9, ...props }) {
    const glyph = ICONS[name];
    if (!glyph) return null;
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
            {...props}
        >
            {glyph}
        </svg>
    );
}
